import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Data = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;

  p {
    margin: 0;
    text-align: center;
    font-size: 14px;
    color: ${tokens.color.text.secondary};
    word-break: break-word;
  }
`
